import script from "./ContentMixin.vue?vue&type=script&lang=js"
export * from "./ContentMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__